import React, { Component, Fragment } from "react";
import { node } from "prop-types";
import ProductBody from "pages/_components/ProductBody";
import ProductHead from "pages/_components/ProductHead";

class ProductDetail extends Component {
    static propTypes = {
        children: node,
    };

    static defaultProps = {
        children: null,
    };

    static Head = ProductHead;

    static Body = ProductBody;

    render() {
        const { children } = this.props;

        return <Fragment>{children}</Fragment>;
    }
}

export default ProductDetail;
